import { SPECIAL_CHARACTERS } from 'root/src/shared/util/regexes';
export function formatMnemonicId(url) {
    return url
        .replaceAll(SPECIAL_CHARACTERS, '')
        .trim()
        .split(' ')
        .join('-')
        .toLowerCase();
}
